import React, {useState, useEffect, useRef} from 'react'
import {
  Button,
  Icon,
  ParagraphText,
  // Select,
  SolidAltArrowLeft,
  SolidAltArrowRight,
} from '@thryvlabs/maverick'
import dayjs from 'dayjs'
import {Spinner} from '../custom/loader-spinner'
import {toast} from 'react-toastify'
import {kP11LinkService} from './kp-11Link-service'
import {useAuthClient} from '../../utils/use-auth-client'
import {ADD_ON} from '../../utils/addons-data'
const SCHEDULE_ROW_COUNT = 4
const SLOT_BTN_WIDTH = 80
// const minDay = 0
// const maxDayRange = 14
let timeZones = [
  {name: 'Hawaii', value: 'Pacific/Honolulu'},
  {name: 'Alaska', value: 'America/Juneau'},
  {name: 'Pacific Time (US & Canada)', value: 'America/Los_Angeles'},
  {name: 'Arizona Time', value: 'America/Phoenix'},
  {name: 'Mountain Time (US & Canada)', value: 'America/Denver'},
  {name: 'Central Time (US & Canada)', value: 'America/Chicago'},
  {name: 'Eastern Time (US & Canada)', value: 'America/New_York'},
]
timeZones = timeZones.map(item => {
  return {
    name: `${dayjs().utc().tz(item.value).format('Z')} ${item.name}`,
    value: item.value,
  }
})

const DEFAULT_TIMEZONE = timeZones.find(
  item => item.value === 'America/Chicago',
)

let SCHEDULE_OPTIONS = []

export const SchedulerAppointmentComponent = ({
  isCreativeCallExist,
  isKickOffCallExist,
  scheduleKickOffCallDetails,
  setScheduledKickOffCallDetails,
  scheduleCreativeCallDetails,
  setScheduledCreativeCallDetails,
  handleScheduleSuccessStatus,
  accountInformation,
  country = 'US',
  transitionData,
  structuredCart,
}) => {
  const slotTargetRef = useRef(null)
  const [selectTimeZone, setSelectedTimeZone] = useState(DEFAULT_TIMEZONE)
  const [selectedHours, setSelectedHours] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null)
  const [isLoading, setLoadingStatus] = useState(false)
  // const [minDate, setMinDate] = useState(dayjs())
  // const [maxDate, setMaxDate] = useState(dayjs())
  const [isConfirmationInitiated, setConfirmationInitiatedStatus] =
    useState(false)
  const [selectedMonth, setSelectedMonth] = useState(
    dayjs().format('MMMM[,] YYYY'),
  )
  const [availableSlotDetails, setAvailableSlotDetails] = useState({
    availableTimes: [],
    serviceIdTitle: {},
    timeZone: {},
  })
  const [selectedCall, setSelectedCall] = useState('')
  const currentSlotScrollPosition = useRef(0)
  const currentDateScrollPosition = useRef(0)
  const client = useAuthClient()

  // Get country from keapPartnerLinkDetail if available, otherwise use prop
  const appointmentCountry =
    transitionData?.state?.keapPartnerLinkDetail?.country_code ||
    country ||
    'US'
  useEffect(() => {
    SCHEDULE_OPTIONS = []
    if (
      isKickOffCallExist &&
      !SCHEDULE_OPTIONS.find(({name}) => name === 'kickoff')
    ) {
      SCHEDULE_OPTIONS.push({
        name: 'kickoff',
        label: 'Marketing Center Kickoff Call',
      })
    }
    if (
      isCreativeCallExist &&
      !SCHEDULE_OPTIONS.find(({name}) => name === 'creative')
    ) {
      SCHEDULE_OPTIONS.push({name: 'creative', label: 'Website Design Call'})
    }
    if (SCHEDULE_OPTIONS.length > 0) {
      setSelectedCall(SCHEDULE_OPTIONS[0].label)
    }
  }, [isCreativeCallExist, isKickOffCallExist])

  const isNewSEO =
    structuredCart?.apps?.some(item => item?.name?.includes('SEO')) || false

  // Check if this is an influencer ops appointment
  const isInfluencerOps = transitionData?.state?.keapPartnerLinkDetail
    ?.influencer_name
    ? true
    : false

  useEffect(() => {
    if (selectedCall === 'Marketing Center Kickoff Call') {
      setOnLoadCallDetails(scheduleKickOffCallDetails)
    } else {
      setOnLoadCallDetails(scheduleCreativeCallDetails)
    }
  }, [selectedCall])

  const getMinDate = () => {
    // Influencer ops: minimum 48 hours from now
    if (isInfluencerOps) {
      return new Date(dayjs().add(48, 'hours'))
    }

    let date = new Date()
    let isCreativeCallTabActive = selectedCall.toLowerCase().includes('website')
    if (
      isCreativeCallTabActive &&
      isKickOffCallExist &&
      scheduleKickOffCallDetails?.isCallScheduled
    ) {
      date = new Date(
        dayjs(scheduleKickOffCallDetails.callDetails.thryvBookingDate).add(
          1,
          'day',
        ),
      )
      return date
    } else if (isNewSEO) {
      date = new Date(dayjs().add(7, 'day'))
      return date
    } else {
      return date
    }
  }

  const getMaxDate = () => {
    let defaultMaxDate = getMinDate()
    // Influencer ops: max 30 days, but cannot go past the 15th
    if (isInfluencerOps) {
      let maxDate = dayjs().add(30, 'days')
      const currentDay = dayjs().date()
      const maxDay = maxDate.date()

      // If current date is after the 15th or max date would go past the 15th of next month
      if (currentDay > 15 || (currentDay <= 15 && maxDay > 15)) {
        // Set max date to the 15th of the current or next month
        if (currentDay > 15) {
          maxDate = dayjs().add(1, 'month').date(15)
        } else {
          maxDate = dayjs().date(15)
        }
      }

      // Ensure we don't exceed 30 days
      const thirtyDaysOut = dayjs().add(30, 'days')
      if (maxDate.isAfter(thirtyDaysOut)) {
        maxDate = thirtyDaysOut
      }

      return new Date(maxDate)
    }

    let isCreativeCallTabActive = selectedCall.toLowerCase().includes('website')
    let dateAdds = [13, 13, 13, 13, 13, 13, 13]
    if (isCreativeCallTabActive && (country === 'AU' || country === 'NZ')) {
      dateAdds = [16, 16, 16, 16, 18, 18, 17]
    }
    if (isNewSEO && !isCreativeCallTabActive) {
      defaultMaxDate = dayjs(defaultMaxDate).add(21, 'day')
      return defaultMaxDate
    }
    const dayOfWeek = new Date().getDay()
    const extendedDay = dateAdds[dayOfWeek]
    defaultMaxDate = dayjs(defaultMaxDate).add(extendedDay, 'day')
    return new Date(defaultMaxDate)
  }

  function includeAddonsCodes(callType, url) {
    // let {selectedCentersNApps} = transitionData
    let allCentersAndApps = [
      ...structuredCart.centers,
      ...structuredCart.apps,
      ...structuredCart.oneTimeFees.filter(
        ({name}) => name === ADD_ON.entitlements['Custom Video'].label,
      ),
    ]
    let ccEntitlements = structuredCart.centers
      .filter(({code}) => !code.startsWith('cc_'))
      .flatMap(item => item.entitlements)
    allCentersAndApps = [...allCentersAndApps, ...ccEntitlements]

    const onboardingAddons = ['HIPAA', 'Restricted Access']

    if (callType === 'kickoff') {
      onboardingAddons.push(
        'Thryv Leads',
        'Marketing Center Plus',
        'SEO Money Back Guarantee',
        'SEO Non-Guaranteed',
        'SEO',
        'Social Ads',
        'Thryv HVAC',
        'Marketing Center Pro',
      )
      if (structuredCart) onboardingAddons.push('Business Center')
    }

    if (callType === 'creative') {
      if (structuredCart) {
        onboardingAddons.push('Custom Video')
        onboardingAddons.push('SEO')
        onboardingAddons.push('Professionally Designed Website')
      }
    }

    let codes = []
    // allCentersAndApps.map(item => {
    //   if (
    //     item &&
    //     item?.name &&
    //     onboardingAddons.includes(item.name) &&
    //     !item?.included
    //   ) {
    //     codes.push(item.name)
    //   }
    //   return item
    // })

    allCentersAndApps.map(item => {
      if (!item) return item

      // check if item is included
      if (item.name && onboardingAddons.includes(item.name) && !item.included) {
        codes.push(item.name)
      }

      // check if any of its addons are included
      if (Array.isArray(item.addons)) {
        item?.addons?.forEach(addon => {
          const matchedAddon = onboardingAddons.find(a =>
            addon.name?.toLowerCase().includes(a.toLowerCase()),
          )

          if (
            matchedAddon &&
            !addon.included &&
            !codes.includes(matchedAddon)
          ) {
            codes.push(matchedAddon)
          }
        })
        // item.addons.forEach(addon => {
        //   if (
        //     addon?.name &&
        //     onboardingAddons.includes(addon.name) &&
        //     !addon?.included
        //   ) {
        //     codes.push(addon.name)
        //   }
        // })
      }

      return item
    })

    return codes.length > 0 ? `${url}&addons=${codes.join(',')}` : url
  }
  function resetCallDetails() {
    setSelectedDate(null)
    setSelectedHours(null)
  }
  function setOnLoadCallDetails(scheduleCallDetails) {
    if (scheduleCallDetails?.isCallScheduled) {
      setSelectedDate(
        dayjs(scheduleCallDetails?.callDetails?.startDateTime).format(
          'YYYY-MM-DD',
        ),
      )
      setSelectedHours(
        dayjs(scheduleCallDetails?.callDetails?.startDateTime).format(
          'YYYY-MM-DD',
        ),
      )
    } else {
      resetCallDetails()
    }
    setAvailableSlotDetails({
      availableTimes: [],
      serviceIdTitle: {},
      timeZone: {},
    })
  }
  function handleTimeZoneChange(timezone) {
    const foundTimeZone = timeZones.find(
      item => item.value === timezone.timeZoneId,
    )
    if (foundTimeZone) {
      setSelectedTimeZone(foundTimeZone)
    } else {
      // Create timezone object dynamically for timezones not in the hardcoded list
      const dynamicTimeZone = {
        name: `${dayjs().utc().tz(timezone.timeZoneId).format('Z')} ${timezone.timeZoneName}`,
        value: timezone.timeZoneId,
      }
      setSelectedTimeZone(dynamicTimeZone)
    }
  }
  const renderDateList = () => {
    let dateArray = []
    let currentDate = getMinDate()
    let finalDate = getMaxDate()
    while (currentDate <= finalDate) {
      dateArray.push(dayjs(currentDate).format('YYYY-MM-DD'))
      currentDate = dayjs(currentDate).add(1, 'days')
    }

    let selectedDateStyle = {borderColor: '#000000', borderWidth: '2px'}
    let unSelectedDateStyle = {borderColor: '#f3f3f3', borderWidth: '1px'}
    return (
      <div className="d-flex gap-4 cursor-pointer">
        {dateArray.map(item => (
          <div
            key={item}
            id={dayjs(item).format('YYYY-MM-DD')}
            className={
              item === selectedDate
                ? 'active-date-slot px-2 py-2 rounded'
                : 'px-2 py-2 rounded'
            }
            style={
              item === selectedDate ? selectedDateStyle : unSelectedDateStyle
            }
            onClick={async () => {
              setLoadingStatus(true)

              let url
              if (selectedCall.includes('Marketing Center')) {
                url = `cc/order/onboarding/available-times?country=${appointmentCountry}&address=${
                  accountInformation.address
                }&languagePreference=en&date=${dayjs(item).format(
                  'YYYY-MM-DD',
                )}&keapClientPortalAccount=true`
              } else {
                url = `cc/order/creative/available-times?country=${appointmentCountry}&address=${
                  accountInformation.address
                }&languagePreference=en&date=${dayjs(item).format(
                  'YYYY-MM-DD',
                )}&keapClientPortalAccount=true`
              }
              url = includeAddonsCodes(
                selectedCall.includes('Marketing Center')
                  ? 'kickoff'
                  : 'creative',
                url,
              )
              setSelectedDate(item)
              setSelectedMonth(dayjs(item).format('MMMM[,] YYYY'))
              // const data = await client(url)
              const data = await kP11LinkService.fetchAvailableTimeSlot(
                client,
                url,
                accountInformation,
              )
              if (data?.warning) {
                toast.warning(data.warning)
              } else {
                if (data?.timeZone) {
                  handleTimeZoneChange(data?.timeZone)
                }
                setAvailableSlotDetails(data)
              }
              setLoadingStatus(false)
              let el = document.getElementById(dayjs(item).format('YYYY-MM-DD'))
              el.scrollIntoView({
                behavior: 'instant',
                block: 'end',
                inline: 'nearest',
              })
            }}
          >
            <ParagraphText
              variant="reg"
              style={{
                color: 'rgb(205, 205, 205)',
                fontWeight: 'bold',
                fontSize: '0.8rem',
              }}
            >
              {dayjs(item).format('ddd').toUpperCase()}
            </ParagraphText>
            <ParagraphText
              variant="reg"
              style={{
                color: 'black',
                fontWeight: 'bold',
                fontSize: '1.5rem',
              }}
            >
              {dayjs(item).format('DD')}
            </ParagraphText>
          </div>
        ))}
      </div>
    )
  }
  const CalendarViewSection = () => {
    return (
      <div className="pb-4">
        <ParagraphText
          variant="reg"
          style={{
            color: 'black',
            fontWeight: 'bold',
            fontSize: '1rem',
          }}
        >
          {selectedMonth}
        </ParagraphText>
        <div className="d-flex gap-4 ">
          <SolidAltArrowLeft
            height={30}
            width={30}
            style={{marginTop: '40px'}}
            onClick={() => {
              let scrollSlot = document.getElementsByClassName('date-scroll')
              if (currentDateScrollPosition.current !== 0) {
                currentDateScrollPosition.current =
                  currentDateScrollPosition.current - 100
                scrollSlot[0].scrollTo({
                  left: currentDateScrollPosition.current,
                  behavior: 'smooth',
                })
              }
            }}
          />
          <div className="hide-scroll overflow-auto date-scroll">
            {renderDateList()}
          </div>
          <SolidAltArrowRight
            height={30}
            width={30}
            style={{marginTop: '40px'}}
            onClick={() => {
              let scrollSlot = document.getElementsByClassName('date-scroll')
              currentDateScrollPosition.current =
                currentDateScrollPosition.current + 100
              scrollSlot[0].scrollTo({
                left: currentDateScrollPosition.current,
                behavior: 'smooth',
              })
            }}
          />
        </div>
      </div>
    )
  }
  const TimeZoneViewSection = () => {
    return (
      <div className="d-flex  justify-content-end align-items-center py-4">
        {/* <section className="d-flex w-100">
          <Select
            selectLabel="Select Region"
            options={timeZones}
            width="lg"
            selectedOption={selectTimeZone}
            setSelectedOption={setSelectedTimeZone}
            withLabel={selectTimeZone.value}
            className="align-self-stretch w-70"
          />
        </section> */}
        <section
          className={` d-flex  gap-4 ${
            availableSlotDetails?.availableTimes.length < 10 ? 'pe-none' : ''
          }`}
        >
          <SolidAltArrowLeft
            height={20}
            width={20}
            fill={
              availableSlotDetails?.availableTimes.length < 10
                ? 'rgba(0,0,0,0.2)'
                : 'black'
            }
            onClick={() => {
              let scrollSlot = document.getElementsByClassName('slot-scroll')
              if (currentSlotScrollPosition.current !== 0) {
                currentSlotScrollPosition.current =
                  currentSlotScrollPosition.current - 100

                scrollSlot[0].scrollTo({
                  left: currentSlotScrollPosition.current,
                  behavior: 'smooth',
                })
              }
            }}
          />
          <SolidAltArrowRight
            height={20}
            width={20}
            style={{fill: 'white'}}
            fill={
              availableSlotDetails?.availableTimes.length < 10
                ? 'rgba(0,0,0,0.2)'
                : 'black'
            }
            onClick={() => {
              let scrollSlot = document.getElementsByClassName('slot-scroll')
              currentSlotScrollPosition.current =
                currentSlotScrollPosition.current + 100
              scrollSlot[0].scrollTo({
                left: currentSlotScrollPosition.current,
                behavior: 'smooth',
              })
            }}
          />
        </section>
      </div>
    )
  }
  const AvailableSlotViewSection = () => {
    return (
      <div className="w-100 border border-style rounded">
        <div
          className="hide-scroll overflow-x-scroll overflow-y-hidden slot-scroll"
          style={{height: '300px'}}
          ref={slotTargetRef}
        >
          {isLoading ? (
            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100 gap-3">
              <Spinner />
              <ParagraphText variant="lg" className="font-bold text-center">
                Checking Availability
              </ParagraphText>
            </div>
          ) : (
            <>
              {availableSlotDetails.availableTimes.length > 0 ? (
                availableSlotDetails.availableTimes.map((item, index) => {
                  return (
                    <div
                      key={index}
                      id={`scroll-slot-row${index}`}
                      className={`d-flex gap-4 my-4 cursor-pointer`}
                    >
                      {availableSlotDetails.availableTimes.map(
                        (subItem, subIndex) => {
                          return subIndex % SCHEDULE_ROW_COUNT === index ? (
                            <div
                              key={`${subItem.startDateTime}-${subIndex}`}
                              id={subItem.startDateTime}
                              className={
                                (selectedHours === subItem
                                  ? 'active-time-slot'
                                  : '') +
                                ' d-flex justify-content-center px-1.5 py-2 align-items-center'
                              }
                              style={{
                                backgroundColor:
                                  selectedHours === subItem
                                    ? '#000000'
                                    : 'white',
                                borderRadius: '5px',
                                border: '1px solid rgba(0,0,0,0.2)',
                              }}
                              onClick={() => {
                                setSelectedHours(subItem)
                                let el = document.getElementById(
                                  `scroll-slot-row${index}`,
                                )
                                el.scrollIntoView({
                                  behavior: 'instant',
                                  block: 'end',
                                  inline: 'nearest',
                                })
                              }}
                            >
                              <span
                                style={{
                                  textAlign: 'center',
                                  width: SLOT_BTN_WIDTH + 'px',
                                  color:
                                    selectedHours === subItem
                                      ? 'white'
                                      : 'black',
                                }}
                                className={JSON.stringify(subItem)}
                              >
                                {dayjs(subItem.startDateTime)
                                  .tz(
                                    availableSlotDetails?.timeZone?.timeZoneId,
                                  )
                                  .format('h:mm a')}
                              </span>
                            </div>
                          ) : (
                            <React.Fragment
                              key={`empty-${subIndex}`}
                            ></React.Fragment>
                          )
                        },
                      )}
                    </div>
                  )
                })
              ) : (
                <section
                  className={
                    'd-flex justify-content-center align-items-center w-100 h-100'
                  }
                >
                  <ParagraphText variant="lg" className="font-bold text-center">
                    {selectedDate
                      ? !availableSlotDetails?.availableTimes?.length &&
                        'No Slot available please search for some other available dates'
                      : 'Please select days to fetch the available slot for the call scheduling'}
                  </ParagraphText>
                </section>
              )}
            </>
          )}
        </div>
      </div>
    )
  }

  async function cancelAppointment({type, apptId, country}) {
    try {
      const data = {
        type,
        demoApptId: apptId,
        country,
      }
      await client('plans/creative', {data, method: 'DELETE'})
    } catch {
      toast.error('error cancelling creative')
    }
  }
  async function confirmScheduling() {
    try {
      setConfirmationInitiatedStatus(true)
      const apptData = {
        firstName: accountInformation.firstName,
        lastName: accountInformation.lastName,
        email: accountInformation.email,
        phone: accountInformation?.mobile,
        company: accountInformation.company,
        isKeapClientPortalReq: true,
      }
      const scheduleInfo = {
        timeZone: availableSlotDetails.timeZone.timeZoneId,
        serviceId: availableSlotDetails?.serviceIdTitle.serviceId,
        staffId: selectedHours.staffId,
        startTime: selectedHours.startTime,
        thryvBookingDate: selectedHours.startDateTime,
        isAus: appointmentCountry === 'AU',
        isNZ: appointmentCountry === 'NZ',
        country: appointmentCountry,
        isApptHold: true,
      }

      let appointment_type = ''
      let existingApptId = ''
      if (selectedCall.includes('Website')) {
        appointment_type = 'creative'
        apptData['creative'] = scheduleInfo
        if (scheduleCreativeCallDetails?.isCallScheduled) {
          existingApptId = scheduleCreativeCallDetails.callDetails.apptId
        }
      } else {
        apptData['onboarding'] = scheduleInfo
        appointment_type = 'onboarding'
        if (scheduleKickOffCallDetails?.isCallScheduled) {
          existingApptId = scheduleKickOffCallDetails.callDetails.apptId
        }
      }

      const {apptId} = await kP11LinkService.confirmScheduleSlot(
        client,
        `plans/${appointment_type}`,
        apptData,
      )
      // const apptId = '1112424234'
      if (apptId) {
        apptData.appointment_type = appointment_type
      }
      if (appointment_type === 'onboarding') {
        setScheduledKickOffCallDetails({
          isCallScheduled: true,
          callDetails: {
            ...apptData[`${appointment_type}`],
            appointment_type,
            apptId,
          },
        })
        if (scheduleCreativeCallDetails?.isCallScheduled) {
          setScheduledCreativeCallDetails(null)
        }
      } else {
        setScheduledCreativeCallDetails({
          isCallScheduled: true,
          callDetails: {
            ...apptData[`${appointment_type}`],
            appointment_type,
            apptId,
          },
        })
      }

      if (existingApptId) {
        await cancelAppointment({
          type: appointment_type,
          country: appointmentCountry,
          apptId: existingApptId,
        })
      }

      setConfirmationInitiatedStatus(false)
      if (appointment_type === 'onboarding') {
        if (SCHEDULE_OPTIONS.length > 1) {
          setSelectedCall(SCHEDULE_OPTIONS[1].label)
        } else {
          handleScheduleSuccessStatus()
        }
      } else {
        handleScheduleSuccessStatus()
      }
      toast.success(`${selectedCall}  confirmed`)
    } catch (err) {
      setConfirmationInitiatedStatus(false)
      if (err.status !== 400) {
        throw err
      }
      err.errors.forEach(({message}) => toast.error(message))
    }
  }

  const getTabStyle = tabLabel => {
    const isSelected = tabLabel === selectedCall
    const isKickoffTab = tabLabel === 'Marketing Center Kickoff Call'

    if (isSelected) {
      return {
        border: isKickoffTab ? '1px solid #5378FC' : '1px solid #000000',
        borderBottom: '0px',
        borderRadius: '5px 5px 0px 0px',
        padding: '5px 10px',
        marginBottom: '-1px',
        backgroundColor: isKickoffTab ? '#5378FC' : '#000000',
        color: 'white',
      }
    } else {
      return {
        border: '1px solid transparent',
        padding: '5px 10px',
        backgroundColor: 'white',
      }
    }
  }

  // const handleScheduleValidationCheck = () => {
  //   if (isKickOffCallExist && !scheduleKickOffCallDetails?.isCallScheduled) {
  //     toast.error('Please schedule a kickoff Call in order proceed further')
  //     return
  //   }
  //   if (isCreativeCallExist && !scheduleCreativeCallDetails?.isCallScheduled) {
  //     toast.error('Please schedule a creative call in order to proceed further')
  //     return
  //   }
  //   handleScheduleSuccessStatus()
  // }

  const renderScheduleSection = () => {
    return (
      <div className={`col align-self-start mt-4`}>
        <CalendarViewSection />
        <TimeZoneViewSection />
        <AvailableSlotViewSection />
        {selectedCall.toLowerCase().includes('website') &&
          isCreativeCallExist &&
          isKickOffCallExist &&
          !scheduleKickOffCallDetails?.isCallScheduled && (
            <section
              className="position-absolute w-100 h-100 fixed-top"
              style={{background: 'white'}}
            >
              <section className="d-flex align-items-center w-100 h-100 text-center">
                <p className="w-100 text-center">
                  Please schedule Kickoff Call before scheduling Creative
                  Call{' '}
                </p>
              </section>
            </section>
          )}
      </div>
    )
  }

  const handleConfirmDisabledCheck = () => {
    let nonSelectedOption = !(selectedDate && selectedHours)
    if (selectedCall.toLowerCase().includes('leads')) {
      if (scheduleKickOffCallDetails?.isCallScheduled) {
        if (
          scheduleKickOffCallDetails?.callDetails?.thryvBookingDate ===
          selectedHours?.startDateTime
        ) {
          return true
        } else {
          return false
        }
      } else {
        return nonSelectedOption
      }
    }
    if (selectedCall.toLowerCase().includes('website')) {
      if (scheduleCreativeCallDetails?.isCallScheduled) {
        if (
          scheduleCreativeCallDetails?.callDetails?.thryvBookingDate ===
          selectedHours?.startDateTime
        ) {
          return true
        } else {
          return false
        }
      } else {
        return nonSelectedOption
      }
    }
    return nonSelectedOption
  }

  console.log({selectTimeZone})
  return (
    <>
      <div
        className="w-100 d-flex"
        style={{maxWidth: '100%', overflow: 'hidden'}}
      >
        <div className="w-40 d-flex mt-4" style={{flexShrink: 0}}>
          <section>
            <section className="d-flex gap-1 align-items-center">
              <Icon
                type="regular"
                variant="calendarClock"
                color="gray"
                height="20"
                width="20"
              />
              <span>30 minutes</span>
            </section>
            <section className="d-flex gap-1 align-items-center">
              <Icon
                type="regular"
                variant="globe"
                color="gray"
                height="20"
                width="20"
              />
              <span>
                {selectTimeZone &&
                  dayjs().tz(selectTimeZone.value).format('zzz')}
              </span>
            </section>
            <br />
            <strong>
              Select a date & time for your upcoming appointments. Time zone
              will update once date is selected.
            </strong>
          </section>
        </div>
        <div
          className="w-60 border-left-style"
          style={{flexShrink: 0, maxWidth: '60%', overflow: 'hidden'}}
        >
          <div className="d-flex border-bottom w-100">
            {SCHEDULE_OPTIONS.map(item => (
              <span
                style={getTabStyle(item?.label)}
                className="cursor-pointer"
                key={item?.label}
                onClick={() => {
                  setSelectedCall(item?.label)
                }}
              >
                {item?.label}
              </span>
            ))}
          </div>
          {renderScheduleSection()}
          <div
            className="d-flex col align-self-end justify-content-end gap-4 mt-2"
            style={{height: '30px'}}
          >
            <Button
              variant="primary"
              style={{borderRadius: '20px!important'}}
              onClick={confirmScheduling}
              disabled={handleConfirmDisabledCheck()}
            >
              Confirm
            </Button>
            {/* {((selectedMonth &&
              selectedHours &&
              isKickOffCallExist &&
              scheduleKickOffCallDetails?.isCallScheduled) ||
              (selectedMonth &&
                selectedHours &&
                isCreativeCallExist &&
                scheduleCreativeCallDetails?.isCallScheduled)) && (
              <Button
                variant="primary"
                style={{borderRadius: '20px'}}
                onClick={handleScheduleValidationCheck}
              >
                Continue
              </Button>
            )} */}
          </div>
        </div>
      </div>

      {isConfirmationInitiated && (
        <div
          style={{
            position: 'fixed',
            width: '100vw',
            height: '100vh',
            top: '0px',
            left: '0px',
            background: 'rgba(0, 0, 0, 0.3)',
            zIndex: 9999,
          }}
        >
          <div className="d-flex justify-content-between align-items-center h-100">
            <Spinner />
          </div>
        </div>
      )}
    </>
  )
}
